import { useState, useCallback } from "react";

interface ConfirmState {
  open: boolean;
  title: string;
  description: string;
  confirmLabel: string;
  variant: "default" | "destructive";
  onConfirm: () => void;
}

const initialState: ConfirmState = {
  open: false,
  title: "",
  description: "",
  confirmLabel: "Confirm",
  variant: "default",
  onConfirm: () => {},
};

export function useConfirm() {
  const [state, setState] = useState<ConfirmState>(initialState);

  const confirm = useCallback(
    (options: {
      title: string;
      description: string;
      confirmLabel?: string;
      variant?: "default" | "destructive";
      onConfirm: () => void;
    }) => {
      setState({
        open: true,
        title: options.title,
        description: options.description,
        confirmLabel: options.confirmLabel || "Confirm",
        variant: options.variant || "default",
        onConfirm: options.onConfirm,
      });
    },
    []
  );

  const onOpenChange = useCallback((open: boolean) => {
    if (!open) {
      setState(initialState);
    }
  }, []);

  return {
    confirmProps: {
      open: state.open,
      onOpenChange,
      title: state.title,
      description: state.description,
      confirmLabel: state.confirmLabel,
      variant: state.variant,
      onConfirm: state.onConfirm,
    },
    confirm,
  };
}
